import { colors } from '@piconetworks/pkg-functions';
import { showConsoleLogs } from '../utils.js';

/**
 * Takes the name, propertyFromApi and serializes values from the FormCustomizations and ThemeCustomizations table to CSS
 */
var PropertySerializer = /*#__PURE__*/function () {
  function PropertySerializer(opts) {
    this.name = opts.name;
    this.propertyFromApi = opts.propertyFromApi;
    this.priority = opts.priority || 100;
    this.convertToRgb = opts.convertToRgb || false;
    // this._hasBeenModified = false

    if (opts.convertValueToCssPropertiesFunction !== undefined) {
      this.convertValueToCssPropertiesFunction = opts.convertValueToCssPropertiesFunction;
    } else {
      this.convertValueToCssPropertiesFunction = function (value) {
        return value;
      };
    }
    this.options = opts.options || undefined;
    if (opts.selectorFunction !== undefined) {
      this.selectorFunction = opts.selectorFunction;
    } else if (opts.selector !== undefined && opts.selectorFunction === undefined) {
      this.selector = opts.selector;
    }
    if (opts.cssVariable !== undefined) {
      this.cssVariable = opts.cssVariable;
      if (opts.cssVariableFunction !== undefined) {
        this.cssVariableFunction = opts.cssVariableFunction;
      }
    }
    if (opts.value !== undefined) {
      this.value = opts.value;
      this.set(opts.value, true);
    } else if (opts.defaultValue !== undefined) {
      this.defaultValue = opts.defaultValue;
      this.set(opts.defaultValue, false);
    }
    this.isCompounded = opts.isCompounded || false;
  }
  var _proto = PropertySerializer.prototype;
  _proto.reset = function reset() {
    if (this.defaultValue) {
      this.set(this.defaultValue, false);
    } else {
      this.value = '';
      this.cssProperties = '';
      this._hasBeenModified = false;
    }
    return this;
  };
  _proto.getValue = function getValue() {
    return this.value;
  };
  _proto.getCssVariableValue = function getCssVariableValue() {
    return this._cssVariableValue;
  };
  _proto.getCssProperties = function getCssProperties() {
    return this.cssProperties;
  };
  _proto.getHasBeenModified = function getHasBeenModified() {
    return this._hasBeenModified;
  };
  _proto.getAll = function getAll() {
    return this;
  };
  _proto.get = function get() {
    return this.cssProperties;
  };
  _proto.set = function set(value, modified) {
    if (modified === void 0) {
      modified = true;
    }
    this.value = value;
    if (this.convertValueToCssPropertiesFunction !== undefined) {
      if (showConsoleLogs()) {
        console.log("convertValueToCssPropertiesFunction() " + this.propertyFromApi);
      }
      var cssProperties = this.convertValueToCssPropertiesFunction(value);
      if (cssProperties !== undefined) {
        this.cssProperties = cssProperties;
      }
    }
    if (this.selectorFunction !== undefined) {
      this.selector = this.selectorFunction(value);
    }
    if (this.cssVariableFunction !== undefined) {
      this._cssVariableValue = this.cssVariableFunction(value);
    } else if (this.cssVariable !== undefined && this.cssVariableFunction === undefined) {
      this._cssVariableValue = value;
    }
    if (this.convertToRgb && value !== 'transparent' && this._cssVariableValue !== undefined) {
      this.stringifiedRgb = this.serializeRgb();
    }
    this._hasBeenModified = modified;
    return this;
  };
  _proto.serializeRgb = function serializeRgb() {
    var colorValue = this._cssVariableValue;
    try {
      var rgbValue = {
        r: null,
        g: null,
        b: null
      };
      if (colors.isHex(colorValue)) {
        rgbValue = colors.hexToRgb(colorValue);
      } else if (colors.isRGBA(colorValue)) {
        rgbValue = colors.rgbaToRgb(colorValue);
      } else if (colors.isRGB(colorValue)) {
        rgbValue = colors.rgbToObject(colorValue);
      }
      if (rgbValue.r === null || rgbValue.g === null || rgbValue.b === null) {
        throw new Error("We couldn't convert the color " + colorValue + " to rgb");
      }
      return rgbValue.r + ", " + rgbValue.g + ", " + rgbValue.b;
    } catch (error) {
      console.error("error converting color " + colorValue + " to rgb:", error);
    }
  };
  return PropertySerializer;
}();

export { PropertySerializer };
//# sourceMappingURL=PropertySerializer.js.map
